
const initialState = {

    mandatoryFieldsBasicDetails: [
        { type: "Reference PPM/RI Work Order No", valueFilled: false, name: 'referenceWorkOrderNo', isVisible: true },
        { type: "Request Details", valueFilled: false, name: 'requestDetails', isVisible: true },
        { type: "Received Date & Time", valueFilled: false, name: 'workorderDateandTime', isVisible: true },
    ],

    assessmentsMandatoryFields: [
        { type: "Responded By", valueFilled: false, name: 'respondedBy', isVisible: true },
        { type: "Responded Start Date and Time", valueFilled: false, name: 'respondedStartDateandTime', isVisible: true },
        { type: "Responded End Date and Time", valueFilled: false, name: 'respondedEndDateandTime', isVisible: true },
        { type: "Task Code", valueFilled: false, name: 'taskCode', isVisible: true },
        { type: "Repair Type", valueFilled: false, name: 'repairType', isVisible: true },
    ],

    completionInfoMandatoryFields: [
        { type: "Response Date & Time", valueFilled: true, name: 'respondedDateandTime', isVisible: true },
        { type: "Completion By", valueFilled: false, name: 'completionBy', isVisible: true },
        { type: "Action Taken", valueFilled: false, name: 'actionTaken', isVisible: true },
    ],
    isMandatoryRequiredEnabled: false,
    isViewEnabled: false,
    isauthorized: false
};

const ScmWorkOrderMandatoryFieldsReducer = (state = initialState, action) => {
    switch (action.type) {
        case "UPDATE_WORK_ORDER_BASIC_DETAILS_MANDATORY_FIELDS":
            return {
                ...state,
                mandatoryFieldsBasicDetails: action.payload,
            };

        case "UPDATE_WORK_ORDER_ASSESMENTS_MANDATORY_FIELDS":
            return {
                ...state,
                assessmentsMandatoryFields: action.payload,
            };

        case "UPDATE_COMPLETION_INFO_MANDATORY_FIELDS":
            return {
                ...state,
                completionInfoMandatoryFields: action.payload,
            };

        case "CLEAR_MANDATORY_FIELD":
            return {};
        default:
            return state;
    }
};

export default ScmWorkOrderMandatoryFieldsReducer;
